var _style, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicLettermark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wonderlic_lettermark_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "106.56 176.05 286.88 147.96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".wonderlic_lettermark_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#wonderlic_lettermark_svg__SVGID_1_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.029,
    y1: 535.865,
    x2: 398.362,
    y2: 385.274,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_lettermark_svg__st0",
    d: "M374.4 176.1c11.2.8 19.7 10.5 19 21.7-.8 11.2-10.5 19.7-21.7 19-11.2-.8-19.7-10.5-19-21.7.8-11.3 10.5-19.8 21.7-19z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000083071764139401995990000008791850755554767035_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.771,
    y1: 505.216,
    x2: 370.104,
    y2: 354.625,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.9 176.1c11.2.8 19.7 10.5 19 21.7-.8 11.2-10.5 19.7-21.7 19-11.2-.8-19.7-10.5-19-21.7.7-11.3 10.5-19.8 21.7-19z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000083071764139401995990000008791850755554767035_)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000068641615310200660950000013536400633313430930_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.255,
    y1: 443.918,
    x2: 313.589,
    y2: 293.328,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.9 176.1c11.2.8 19.7 10.5 19 21.7-.8 11.2-10.5 19.7-21.7 19-11.2-.8-19.7-10.5-19-21.7.7-11.3 10.4-19.8 21.7-19z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000068641615310200660950000013536400633313430930_)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000047771561938063783840000002747814259857654458_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.951,
    y1: 413.22,
    x2: 285.285,
    y2: 262.629,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.3 176.1c11.2.8 19.7 10.5 19 21.7-.8 11.2-10.5 19.7-21.7 19-11.2-.8-19.7-10.5-19-21.7.8-11.3 10.5-19.8 21.7-19z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000047771561938063783840000002747814259857654458_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000161593601590954197460000003582136361491801257_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.877,
    y1: 469.539,
    x2: 337.211,
    y2: 318.949,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.3 320.2c-8.3-6.3-10-18.1-3.8-26.4l54.1-72.2c6.3-8.3 18.1-10 26.4-3.8 8.3 6.3 10 18.1 3.8 26.4l-54.1 72.2c-6.3 8.4-18.1 10.1-26.4 3.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000161593601590954197460000003582136361491801257_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000053543415405496268520000002716370439579526824_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.433,
    y1: 454.957,
    x2: 323.766,
    y2: 304.366,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.2 284.9c-8.3-6.3-10-18.1-3.8-26.4l27.6-36.8c6.3-8.3 18.1-10 26.4-3.8 8.3 6.3 10 18.1 3.8 26.4l-27.6 36.8c-6.2 8.3-18 10-26.4 3.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000053543415405496268520000002716370439579526824_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000111148926491498214490000009087309365659932087_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.447,
    y1: 402.911,
    x2: 275.78,
    y2: 252.32,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.3 264.6c-8.3-6.3-10-18.1-3.8-26.4l12.4-16.6c6.3-8.3 18.1-10 26.4-3.8 8.3 6.3 10 18.1 3.8 26.4l-12.4 16.6c-6.2 8.4-18.1 10-26.4 3.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000111148926491498214490000009087309365659932087_)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000183933179316764540890000011517736210146884523_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.109,
    y1: 445.929,
    x2: 315.442,
    y2: 295.338,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.1 207.6c11.2.8 19.7 10.5 19 21.7-.8 11.2-10.5 19.7-21.7 19-11.2-.8-19.7-10.5-19-21.7.7-11.3 10.4-19.8 21.7-19z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000183933179316764540890000011517736210146884523_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_lettermark_svg__SVGID_00000129923816745719978970000001685130865526874791_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.047,
    y1: 393.8,
    x2: 267.38,
    y2: 243.209,
    gradientTransform: "matrix(1 0 0 -1 0 605.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.1 320.2c-8.3-6.3-10-18.1-3.8-26.4l30.6-40.8c6.3-8.3 18.1-10 26.4-3.8 8.3 6.3 10 18.1 3.8 26.4l-30.6 40.8c-6.2 8.4-18 10.1-26.4 3.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_lettermark_svg__SVGID_00000129923816745719978970000001685130865526874791_)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicLettermark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_lettermark.7fc042d30eeddb5c5fca23939ee94d11.svg";